/**
 * Copyright Motili Inc., 2016 All Rights Reserved
 */


import React from 'react';

import MotiliHeaderBlueOnWhite from '../common/Header';
import Config from '../../../Config';

/**
 * NotFound
 *
 */
module.exports = class NotFound extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // Did Mount
    }

    render() {
        return (
            <MotiliHeaderBlueOnWhite
                error={{message: `Page Not Found - v${Config.version}`}}
            />
        );
    }
};



// WEBPACK FOOTER //
// ./src/app/components/not-found/NotFound.js